/*
 * Constants to represent the keys of metrics used by Plan Builder.
 */
const METRIC_KEYS = {
    carbonSaving: 't-co2',
    fuelBill: 'fuel-bill',
    sapScore: 'sap-score',
}

export default METRIC_KEYS
